import { useSuspenseQuery } from '@tanstack/react-query';
import { getMetaCaseQuery } from 'vl-common/src/schemas/getMetaCase';
import { useSessionAppointment } from '@hooks/useSessionAppointment';

const useAppointmentCaseMeta = () => {
  const { appointment } = useSessionAppointment();

  return useSuspenseQuery(getMetaCaseQuery({ case_id: appointment.case_id }));
};

export default useAppointmentCaseMeta;
